import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    paperClasses,
    styled,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import FloatingBox from '@@components/FloatingBox';
import Icon from '@@components/Icon/Icon';

import ShortcutsList from './ShortcutsList';
import { useShortcut } from '../useShortcut';
import { useShortcutsDialog } from '../useShortcutsDialog';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    [`& .${paperClasses.root}`]: {
        maxWidth: theme.fixed.shortcutsDialog.maxWidth,
    },
}));

const ShortcutsDialog = () => {
    const { t } = useTranslation();
    const { isOpen, close, toggle } = useShortcutsDialog();

    useShortcut('showShortcuts', toggle, { ignoreWhenTyping: true });

    return (
        <StyledDialog
            open={isOpen}
            onClose={close}
            aria-labelledby="shortcuts-dialog-title"
            maxWidth={false}
            fullWidth
        >
            <FloatingBox anchor={null}>
                <IconButton title={t('shortcuts.dialog.closeButton.title')} onClick={close}>
                    <Icon name="xmark" />
                </IconButton>
            </FloatingBox>

            <DialogTitle id="shortcuts-dialog-title" variant="title3">
                {t('shortcuts.dialog.title')}
            </DialogTitle>
            <DialogContent>
                <ShortcutsList />
            </DialogContent>
        </StyledDialog>
    );
};

export default ShortcutsDialog;
